module.exports = __webpack_public_path__ + "img/loginPageLeftImg.1e5d4756.png";